import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Check, Loader } from 'lucide-react';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('processing');
  const [productKey, setProductKey] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const processPayment = async () => {
      if (!sessionId) {
        setStatus('error');
        return;
      }

      try {
        const response = await fetch('/process-payment.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ session_id: sessionId })
        });

        const result = await response.json();

        if (result.success) {
          // Save session token to cookie
          if (result.session_token) {
            document.cookie = `session_token=${result.session_token}; path=/; max-age=2592000`; // 30 days
          }
          setProductKey(result.product_key);
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch (error) {
        console.error('Error processing payment:', error);
        setStatus('error');
      }
    };

    processPayment();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      
      <div className="max-w-3xl mx-auto px-6 py-32">
        <div className="bg-white rounded-2xl p-12 text-center shadow-sm border border-stone-200">
          
          {status === 'processing' && (
            <>
              <div className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-6">
                <Loader className="w-10 h-10 text-blue-600 animate-spin" />
              </div>
              <h1 className="text-3xl font-serif text-stone-900 mb-4">
                Processing Your Purchase...
              </h1>
              <p className="text-stone-600">Please wait a moment</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
                <Check className="w-10 h-10 text-green-600" />
              </div>
              
              <h1 className="text-3xl font-serif text-stone-900 mb-4">
                Payment Successful!
              </h1>
              
              <p className="text-stone-600 text-lg mb-8">
                Thank you for your purchase. You now have access to your guide.
              </p>
              
              <div className="space-y-4">
                {productKey && (
                  <Link
                    to={`/city/${productKey.replace('-guide', '')}`}
                    className="inline-block px-8 py-3 bg-stone-900 text-white rounded-full font-medium hover:bg-stone-800 transition-colors"
                  >
                    View Your Guide
                  </Link>
                )}
                
                <p className="text-sm text-stone-500">
                  Session ID: {sessionId}
                </p>
              </div>
            </>
          )}

          {status === 'error' && (
            <>
              <h1 className="text-3xl font-serif text-stone-900 mb-4">
                Something Went Wrong
              </h1>
              <p className="text-stone-600 mb-8">
                Please contact us at ciao@italianinsiders.com with your session ID.
              </p>
              <p className="text-sm text-stone-500">
                Session ID: {sessionId}
              </p>
            </>
          )}
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PaymentSuccessPage;
